import React, { useMemo } from 'react';
import { PageProps } from 'gatsby';
import { HeaderContainer, HeaderPositioning } from './Header.styles';
import { createHeaderLinks } from './HeaderLinks';
import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';
import { useHeaderCustomization } from 'src/hooks/useHeaderCustomization';

export type MainLayout = 'standard' | 'pro';

export interface HeaderProps {
  mainLayout?: MainLayout;
  locationProps: PageProps['location'];
}

const Header = ({ locationProps, mainLayout }: HeaderProps): JSX.Element => {
  const isPro = useMemo(() => {
    return mainLayout === 'pro' || /^\/pro(?:\/|$)/.test(locationProps.pathname);
  }, [locationProps.pathname, mainLayout]);

  const { mobileBreakpoint = 'lg' } = useHeaderCustomization();

  // TODO (MKT-9342): Sidenav is not yet ready
  const { topBarLinks, sideBarLinks } = useMemo(() => {
    const topBarLinks = createHeaderLinks('top_menu');
    const sideBarLinks = createHeaderLinks('side_menu');

    return { topBarLinks, sideBarLinks };
  }, []);

  const preventMobileTransition = mobileBreakpoint === 'none';

  return (
    <HeaderPositioning>
      <HeaderContainer
        id='header'
        position='static'
        justify='flex-start'
        align='center'
        direction='row'
        maxWidth='width-3xl'
        margin={['spacing-none', 'spacing-auto']}
        padding={['spacing-none', 'spacing-4xl']}
        paddingLg={['spacing-none', 'spacing-lg', 'spacing-none', 'spacing-xl']}
      >
        <HeaderDesktop
          isPro={isPro}
          hideOn={preventMobileTransition ? undefined : mobileBreakpoint}
          topBarLinks={topBarLinks}
          locationProps={locationProps}
        />
        {!preventMobileTransition && (
          <HeaderMobile
            isPro={isPro}
            showOn={mobileBreakpoint}
            sideBarLinks={sideBarLinks}
            locationProps={locationProps}
          />
        )}
      </HeaderContainer>
    </HeaderPositioning>
  );
};

export default Header;
